import styled from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Wrapper: styled.div<{ $isGeneral?: boolean }>`
    display: flex;
    flex-direction: column;
    background: ${({ $isGeneral }) => ($isGeneral ? COLORS.GRAY_100 : '#fff')};
  `,

  ProgressWrapper: styled.div`
    margin-bottom: 16px;
  `,

  StyledContainer: styled(Container)`
    padding: 24px 16px;
    position: relative;
    touch-action: none;
    overscroll-behavior: none;
    justify-content: flex-start;
    height: calc(100dvh - var(--header-height));
    overflow: hidden;

    ${anatomyCompact} {
      overflow-y: auto;
    }
  `,

  DarkOverlay: styled.div<{ $visible?: boolean }>`
    position: fixed;
    inset: 0;
    background: #2b2b2b;
    z-index: 5;
    pointer-events: none;
    opacity: ${({ $visible }) => ($visible ? 0.7 : 0)};
    transition: opacity 0.4s ease;
  `,

  ScratchSection: styled.div<{ $finished?: boolean }>`
    position: ${({ $finished }) => ($finished ? 'absolute' : 'relative')};
    z-index: 6;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: ${({ $finished }) => ($finished ? '50%' : 'auto')};
    left: ${({ $finished }) => ($finished ? '0' : 'auto')};
    transform: ${({ $finished }) => ($finished ? 'translateY(-50%)' : 'none')};

    ${anatomyCompact} {
      position: relative;
      top: auto;
      left: auto;
      transform: none;
    }
  `,

  Title: styled.h1`
    text-align: start;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    color: ${COLORS.BLACK};
    margin-bottom: 8px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f24};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh30};
    }
  `,

  Subtitle: styled.p`
    text-align: start;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: ${COLORS.BLACK};
    margin-bottom: 32px;

    ${anatomyCompact} {
      margin-bottom: ${ANATOMY_COMPACT.spacing.s32};
    }
  `,

  AppliedText: styled.p`
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    color: #ffffff;
  `,

  ConfettiAnimation: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100dvh;
    pointer-events: none;
    z-index: 10;
  `,

  BottomSection: styled.div`
    margin-top: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: sticky;
    bottom: 0;
    z-index: 6;
  `,

  ContinueButton: styled(Button)`
    margin-top: 32px;
    width: 100%;
  `,
} as const
